import { CustomTypographyComponentProps } from "../types";
import { Typography } from "@mui/material";

export const H4Typography = ({
  children,
  ...props
}: CustomTypographyComponentProps) => {
  return (
    <Typography variant="h4" {...props}>
      {children}
    </Typography>
  );
};
